import { TranslatedLayout } from './TranslatedLayout';
import { RedirectToUrlWithLanguageCode } from './RedirectToUrlWithLanguageCode';
import React from 'react';
import glue from '../glue';
const addLangInAbsolutePath = (routes, lang) => {
    let returnArray = [];
    routes.forEach((route) => {
        var _a;
        returnArray.push(Object.assign(Object.assign({}, route), { path: ((_a = route === null || route === void 0 ? void 0 : route.path) === null || _a === void 0 ? void 0 : _a.charAt(0)) === '/' ? '/' + lang + route.path : route.path, children: route.children ? addLangInAbsolutePath(route.children, lang) : undefined }));
    });
    return returnArray;
};
export const computeRouteForI18n = (routes) => {
    let futuresRoutes = [];
    // If frontend translation are enabled and if there is at let one route where i18n is enabled
    const i18nEnabled = glue.isFrontTranslationEnabled() && routes.some((route) => !route.i18nDisable);
    if (i18nEnabled) {
        // Add parent routes with translation enabled for each active lang
        glue.frontAvailableLanguages.forEach((lang) => {
            futuresRoutes.push({
                path: '/' + lang,
                element: React.createElement(TranslatedLayout, null),
                children: addLangInAbsolutePath(routes.filter((route) => !route.i18nDisable), lang),
            });
        });
        // Add parent routes with no translation enabled
        routes
            .filter((route) => route.i18nDisable)
            .forEach((route) => {
            futuresRoutes.push(route);
        });
        // Add a catch all routes to redirect to localized routes
        futuresRoutes.push({
            path: '*',
            element: React.createElement(RedirectToUrlWithLanguageCode, null),
        });
    }
    else {
        futuresRoutes = routes;
    }
    return futuresRoutes;
};
//# sourceMappingURL=computeRouteForI18n.js.map